import { useState } from 'react';
import { Button, Descriptions, Message, Space, Typography } from '@arco-design/web-react';
import { adminReconcileApi } from '@/api';
import type { UpstreamAccountBalance } from '@/types/reconcile';
import { formatMoney } from '@/utils/money';

export default function UpstreamReconcileView() {
  const [loading, setLoading] = useState(false);
  const [balance, setBalance] = useState<UpstreamAccountBalance | null>(null);

  const onFetchBalance = async () => {
    setLoading(true);
    try {
      const data = await adminReconcileApi.fetchUpstreamBalance();
      setBalance(data);
      Message.success('已获取上游账户余额');
    } catch {
      setBalance(null);
    } finally {
      setLoading(false);
    }
  };

  const currency = (balance?.currency ?? 'USD') as 'USD';

  return (
    <div className="admin-page">
      <div className="admin-page__header">
        <div>
          <div className="admin-page__title">与上游对账</div>
          <div className="admin-page__subtitle">
            调用 Newgen §9 Retrieve account balance，查询上游商户账户可用余额
          </div>
        </div>
      </div>

      <div className="admin-card">
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Button type="primary" loading={loading} onClick={onFetchBalance}>
            获取上游余额
          </Button>

          {balance ? (
            <Descriptions
              column={1}
              border
              labelStyle={{ width: 160 }}
              data={[
                {
                  label: '账户余额',
                  value: (
                    <Typography.Text style={{ fontSize: 20, fontWeight: 600 }}>
                      {formatMoney(balance.balanceCents, currency)}
                    </Typography.Text>
                  ),
                },
                {
                  label: '余额（美分）',
                  value: balance.balanceCents.toLocaleString('en-US'),
                },
                { label: '币种', value: balance.currency },
                {
                  label: '获取时间',
                  value: new Date(balance.fetchedAt).toLocaleString('zh-CN', {
                    hour12: false,
                  }),
                },
              ]}
            />
          ) : (
            <Typography.Text type="secondary">
              点击「获取上游余额」后，将在此展示上游返回的账户余额
            </Typography.Text>
          )}
        </Space>
      </div>
    </div>
  );
}
